/* ----------------------- */
/* ----- FontAwesome ----- */
/* ----------------------- */

import './bootstrap.js';

import { library, dom } from 'laravel-core/@fortawesome/fontawesome-svg-core';
import * as icons from './icons';
library.add(...Object.values(icons));
dom.watch();